export default [
  {
    _name: 'CSidebarNav',
    _children: [        
      {
        _name: 'CSidebarNavTitle',
        _children: ['Currículos']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Ativos',
        to: '/ativos',
        icon: 'cil-cursor'        
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Arquivados',
        to: '/arquivados',
        icon: 'cil-bell'        
      }, 
      {
        _name: 'CSidebarNavItem',
        name: 'Consultar',
        name: 'Todos',
        to: '/curriculos',        
        icon: 'cil-puzzle'        
      },
      /* {
        _name: 'CSidebarNavItem',
        name: 'Panorama',
        to: '/panorama',
        icon: 'cil-calculator'        
      }, */
      
            
      
                        
      {
        _name: 'CSidebarNavDivider',
        _class: 'm-2'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Conta']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Definições',
        to: '/definicoes',
        icon: 'cil-user',        
      },      
    ]
  }
]